<template>
  <div
    class="select-none transform transition-all duration-600 h-10 text-white rounded-md flex items-center text-sm">
      <slot name="commons" />
      <div class="hidden md:block">
        <slot name="desktop" />
      </div>
      <div
        ref="moreSection"
        v-outside:click="{ exclude: ['moreSection'], handler: closeMore }"
        class="relative">
        <base-button
          @click="toggleMore"
          mode="secondary"
         >
          <!-- <base-icon name="more"/> -->
          <span class="count font-bold whitespace-nowrap w-18 text-center"> {{ name }}</span>
          <base-icon v-if="baseDropDownVisible" 
            :class="{'transform rotate-180':more}"
            class="transition-transform duration-300 ml-2"
            name="chevronup"/>
        </base-button>
        <base-drop-down v-if="baseDropDownVisible" 
          autoClose 
          :isOpen="more" 
          position="bottom-right" 
          customClass="w-72 p-1 bg-secondary-800 bottom-10" 
          @toggle="closeMore" >
          <slot name="more" />
        </base-drop-down>
      </div>
    </div>
</template>

<script>
import { i18n } from '@/i18n'
export default {
  name: 'base-table-select-actions-form',
  props: {
    name: {
      type: [String],
      default: i18n.tc('app.actions', 2)
    },
    baseDropDownVisible: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      more: false,
      core: false
    }
  },
  computed: {
  },
  methods: {
    toggleMore: function () {
      this.more = !this.more
    },
    toggleCore: function () {
      this.core = !this.core
    },
    closeMore: function () {
      this.more = false
    },
    closeCore: function () {
      this.core = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
